import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { RawMaterialMasterTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<RawMaterialMasterTheme>;
const css = baseCss as ThemedCssFunction<RawMaterialMasterTheme>;

export const RawMaterialMaster = styled.div`
  width: 100%;
  height: 100%;
`;
